<template>
  <DxForm id="formularioServicioEnergia" ref="formInstance" :form-data="model" label-location="top" :show-colon-after-label="false" :visible="model != null"
    validation-group="validacionServicioEnergia">
    <DxColCountByScreen :xs="6" :sm="6" :md="6" :lg="6" />

    <DxGroupItem :col-span="6" :col-count="6">
      <DxSimpleItem :col-span="2">
        <DocumentCard ref="documentCard" :title="$t('servicio_energia.form.titulo_texto_anexo')" :initial-document-list="documentoAsociado"
          :required="false" layout="default" :max-files="1" :multiple="false"
          :actions="props.tieneTramitesAsociados ? ['open', 'download'] : ['open', 'replace', 'download', 'add']" @updated:document="seleccionarDocumento" @added:document="seleccionarDocumento" />
      </DxSimpleItem>
      <DxEmptyItem :col-span="4" />
    </DxGroupItem>
  </DxForm>
</template>

<script setup lang="ts">
import {
  DxForm,
  DxColCountByScreen,
  DxEmptyItem,
  DxSimpleItem,
  DxGroupItem
} from "devextreme-vue/form";
import type { CreateServicioEnergiaModel, DetailServicioEnergiaModel } from "@api/api";
import DocumentCard from "@/.shared/components/document-card/DocumentCard.vue";
import { computed, ref } from "vue";
import type { CardFile } from "@/.shared/components/document-card/models/CardFile";
import { uniqueId } from "lodash";
import type { IDocumentInitialState } from "@/.shared/components/document-card/models/IDocumentCardProps";

const documentoASubir = ref<File>();
const documentCard = ref<InstanceType<typeof DocumentCard>>();

const props = defineProps({
  model: {
    type: Object as () => DetailServicioEnergiaModel | CreateServicioEnergiaModel,
    required: true
  },
  tieneTramitesAsociados: {
    type: Boolean,
    required: true
  }
})

const documentoAsociado = computed<IDocumentInitialState[]>(() => {
  const remoteUri = (props.model as DetailServicioEnergiaModel).Anexo ?? null;

  if (!remoteUri) {
    return [];
  }

  return [{
    id: uniqueId(),
    uri: remoteUri,
    fileName: remoteUri.split('/').pop() ?? '',
    description: undefined
  }];
})

const seleccionarDocumento = (ficheroSeleccionado: CardFile) => {
  documentoASubir.value = ficheroSeleccionado.file ?? undefined;
}

async function validate(): Promise<boolean> {
  return documentCard.value?.isValid ?? false;
}

defineExpose({ documentoASubir, validate })

</script>


<style lang="scss" scoped>


.document-card {
  margin-top: 20px;
}
</style>